import pageTitle from 'ember-page-title/helpers/page-title';
import t from 'ember-intl/helpers/t';
<template>{{pageTitle (t "general.logout")}}</template>
